import EmpManage from './empManage.vue'
import Add from './add/add-routing'

export default [{
    path: '/empManage',
    name:'empManage',
    component:EmpManage,
    children:[...Add]
}]